import { Suspense } from 'react';
import BaseLayout from '../../layouts/BaseLayout';

export const withSuspenseFallback = (Component) => (props) =>
  (
    <Suspense fallback={<BaseLayout loading />}>
      <Component {...props} />
    </Suspense>
  );
